import { render, staticRenderFns } from "./ManageEmployeesGroupForm.vue?vue&type=template&id=2be4a890&scoped=true"
import script from "./ManageEmployeesGroupForm.vue?vue&type=script&lang=js"
export * from "./ManageEmployeesGroupForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be4a890",
  null
  
)

export default component.exports